"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HumanPart = exports.calcFlip = void 0;
exports.calcFlip = (d) => (d > 3 && d < 7 ? 6 - d : d);
class HumanPart {
    constructor(props) {
        this.lib = null;
        this.size = 'h';
        this.assetpartdefinition = 'std';
        this.type = null;
        this.id = '1';
        this.direction = 0;
        this.frame = 0;
        this.tint = 0xffffff;
        this.alpha = 100;
        this.dx = 0;
        this.dy = 0;
        Object.assign(this, props);
    }
    buildPartName(options) {
        options = Object.assign({}, this, options);
        return [options.size, options.assetpartdefinition, options.type, options.id, options.direction, options.frame].join('_');
    }
    buildFilenameName(options) {
        options = Object.assign({}, this, options);
        const parts = [options.lib, this.buildPartName(options)].join('_');
        return `${parts}.png`;
    }
    setBase(base) {
        const parts = base.split('_');
        this.id = parts.pop();
        this.type = parts.join('_');
        return this;
    }
}
exports.HumanPart = HumanPart;
